
export const PAYMENT_MESSAGE = {
    success: "Payment successful",
    cancelled: "Payment cancelled",
    error: "Payment failed",
    inProcess: "Payment is in-process",
    insufficientBalance: "Payment failed, Insufficient balance!"
}